import { AssignmentFilterModel, CustomerAddressModel, CustomerContactDetailsModel, CustomerFilterModel, CustomerModel, Input, SuperBit_swaggerClient, TreatmentFilterModel } from './superbit-api-models';
import generalSettings from '../json/general-settings.json';
import moment from 'moment';

export class SigningModel {
    client: any;
    constructor() {
        const apiUrl = localStorage.getItem('apiUrl');
        this.client = new SuperBit_swaggerClient(apiUrl ? apiUrl : generalSettings.apiUrl);
    }

    async signingFilter(request: any) {
        return this.client.signingFilter(request)
    }

    signingExportToExcel(request: any) {
        return this.client.signingExportToExcel(request);
    }

    async signingDelete(id: string) {
        return this.client.signingDelete(id);
    }

    async getStatuses() {
        return this.client.getElementaryPolicyStatuses();
    }

    async addStatus(body: any) {
        return this.client.addElementaryPolicyStatus(body);
    }

    async deleteStatus(id: string) {
        return this.client.deleteElementaryPolicyStatus(id);
    }

    async riderUpdateStatus(body: any) {
        return this.client.riderUpdateStatus(body);
    }

    formatDate(d: Date) {
        if (d) {
            return moment(d).format('YYYY-MM-DD');
        }
        return undefined;
    }
}